// Approved Front Desk personal self-service, including own request forms. The server enforces
// the corresponding API boundary; these routes keep navigation coherent.
export const FRONT_DESK_DESTINATIONS = [
  { id: 'my-day', label: 'My day', to: '/my-day', glyph: 'today' },
  { id: 'today', label: 'My schedule', to: '/my-schedule', glyph: 'today' },
  { id: 'profile', label: 'Profile', to: '/profile', glyph: 'profile' },
  { id: 'time-off', label: 'Time-Off', to: '/scheduling/time-off', glyph: 'team' },
  { id: 'swaps', label: 'Shift Swap', to: '/help-a-teammate/swaps', glyph: 'team' },
  { id: 'preferences', label: 'Scheduling preferences', to: '/scheduling/preferences', glyph: 'team' },
];

export function frontDeskRouteAllowed(user, pathname) {
  if (user?.role !== 'front_desk') return true;
  return ['/my-day', '/profile', '/my-schedule', '/scheduling/preferences', '/scheduling/time-off', '/help-a-teammate/swaps', '/settings/backgrounds'].includes(pathname) || /^\/documents\/workflow\/doc_[A-Za-z0-9]+$/.test(pathname) || /^\/help-a-teammate\/swaps\/[A-Za-z0-9_-]+$/.test(pathname);
}
